import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const pageApi = {
  getPages: (params) => {
    const url = "page";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getPage: (id) => {
    const url = "page";
    return axiosClient.get(url + "/" + id);
  },

  createPage: (params) => {
    const url = "page";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  updatePage: (id, payload) => {
    const url = "page/";
    return axiosClient.patch(url + id, payload);
  },
  // deletePage: (id) => {
  //   const url = "Page/";
  //   return axiosClient.delete(url + id);
  // },
  deletePage: (params) => {
    const url = "page";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default pageApi;
